const STORAGE_KEYS = {
    MASTER_DATA: "master_data",
};

const TTL = {
    MASTER_DATA: 1000 * 60 * 60, // 1 hour (optional)
};

export const setStorage = (key, data) => {
    const payload = {
        data,
        timestamp: Date.now(),
    };
    localStorage.setItem(key, JSON.stringify(payload));
};

export const getStorage = (key, ttl = null) => {
    const item = localStorage.getItem(key);
    if (!item) return null;

    try {
        const parsed = JSON.parse(item);

        // TTL check
        if (ttl && Date.now() - parsed.timestamp > ttl) {
            localStorage.removeItem(key);
            return null;
        }

        return parsed.data;
    } catch (e) {
        localStorage.removeItem(key);
        return null;
    }
};

export const STORAGE = STORAGE_KEYS;
export const STORAGE_TTL = TTL;